import { Component, OnInit } from '@angular/core';
import { Job } from '@contracts/interfaces/job.interface';
import { JobService } from '../../services/job.service';
import { StatusService } from '../../services/status.service';
import { Kios } from 'src/app/services/kios.service';


@Component({
  selector: 'ap-status',
  templateUrl: './status.component.html',
  styleUrls: ['./status.component.scss']
})
export class StatusComponent implements OnInit {

    updateInterval: any;

    bankSyncJobID: null | string = "";
    backupSyncJobID: null | string = "";

    public statusText = "";

    public isJob = false;

    constructor(
        public statusService: StatusService,
        private jobService: JobService,
        private kios: Kios
    ) { }

  ngOnInit(): void {
    this.loadJobs();

    this.jobService.find({}).subscribe((jobs: any) => {
      // console.log(jobs)
    });

    this.updateInterval = setInterval(async () => {
      this.loadJobs();
    }, 750);
  }

  loadJobs() {

    this.jobService.find({
        state: "active"
    }).subscribe((jobs: any) => {
        if (jobs.length > 0) {
          this.isJob = true;
          this.statusText = jobs[0].log[jobs[0].log.length-1];
        } else {
            this.isJob = false;
            this.statusText = "";
        }
    });
  }

  bankSyncJob() {
    this.jobService.create({
      job: Job.BANK_SYNC,
      date: {
        start: new Date()
      },
      data: {}
    }).subscribe((jobID: any) => {
        this.bankSyncJobID = jobID;
    });
  }

  backupJob() {
    this.jobService.create({
      job: Job.BACKUP,
      date: {
        start: new Date(),
      },
      data: {}
    }).subscribe((jobID: any) => {
        this.backupSyncJobID = jobID;
    });
  }

  kiosMode() {
    this.kios.enterKiosMode();
  }
}
